import React from "react";
import MainEducation from "../../Components/Products/education";

const Education = () => {
	return <MainEducation />;
};

export default Education;
